export const Specialist = {
  Cardiology: 'Cardiology',
  Dermatology: 'Dermatology',
  Gastroenterology: 'Gastroenterology',
  Nephrology: 'Nephrology',
  Pulmonology: 'Pulmonology',
};
